import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import AuthPrivacyFooter from './AuthPrivacyFooter'
import {AUTH_DIALOG_WIDTH} from './AuthenticationDialog'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import EmailPasswordAuthForm from './EmailPasswordAuthForm'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'






const StyledDialog = styled(InviteDialog)({
  maxWidth: AUTH_DIALOG_WIDTH
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationEmailCreateAccount = (props) => {
  const {invitationToken, verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationEmailCreateAccount_verifiedInvitation on VerifiedInvitationPayload {
        meetingName
        teamInvitation {
          email
        }
        teamName
      }
    `,
    verifiedInvitationRef
  )
  const {meetingName, teamName, teamInvitation} = verifiedInvitation
  useDocumentTitle(`Sign up | Team Invitation`, 'Sign Up')
  if (!teamInvitation) return null
  const {email} = teamInvitation
  return (
    _jsxs(StyledDialog, { children: [
      _jsx(DialogTitle, { children: meetingName ? `Join ${meetingName}` : 'Join Team'})
      , _jsxs(DialogContent, { children: [
        _jsxs(InvitationDialogCopy, { children: ["Choose a password for immediate access"

          , meetingName ? ' to the team meeting for: ' : ' to your team: '
          , _jsx(TeamName, { children: teamName})
        ]})
        , _jsx(InvitationCenteredCopy, { children: 
          _jsx(EmailPasswordAuthForm, { email: email, isPrimary: true, invitationToken: invitationToken,} )
        })
        , _jsx(AuthPrivacyFooter, {} )
      ]})
    ]})
  )
}

export default TeamInvitationEmailCreateAccount
